var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconoEditar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_25588",
    "data-name": "Grupo 25588",
    transform: "translate(-1744 -126)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_25532",
    "data-name": "Grupo 25532"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_25481",
    "data-name": "Grupo 25481",
    transform: "translate(1744 126)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_2133",
    "data-name": "Elipse 2133",
    cx: 24,
    cy: 24,
    r: 24,
    transform: "translate(0 0)",
    fill: "#003763"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_25554",
    "data-name": "Grupo 25554",
    transform: "translate(1758.064 139)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_69343",
    "data-name": "Trazado 69343",
    d: "M945.386,302.007a3.085,3.085,0,0,0-4.36,0l-13.84,13.84a4.232,4.232,0,0,0-1.247,3.009V320.6a.852.852,0,0,0,.852.851h1.746a4.227,4.227,0,0,0,3.009-1.246l13.841-13.841A3.086,3.086,0,0,0,945.386,302.007Zm-15.044,17a2.573,2.573,0,0,1-1.806.747h-.9v-.9a2.537,2.537,0,0,1,.747-1.8l10.5-10.5,1.958,1.957Zm13.84-13.841L942.05,307.3l-1.958-1.954,2.133-2.133a1.383,1.383,0,0,1,1.954,1.958h0Z",
    transform: "translate(-925.939 -301.105)",
    fill: "#f8fbfd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoEditar);
export default __webpack_public_path__ + "static/media/Icono-Editar.a37a40e4d3687a8f91488d0c53ddc6da.svg";
export { ForwardRef as ReactComponent };